exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-bar-layout--open{position:fixed;inset:0;z-index:50;--tw-bg-opacity:1;background-color:rgb(19 19 19/var(--tw-bg-opacity));display:flex;flex-direction:column;justify-content:flex-start;padding:1rem;padding-top:65px}@media (min-width:1000px){.filter-bar-layout{display:flex;flex-direction:column;position:static;z-index:auto;background-color:transparent;padding:0;margin-top:2rem}}", ""]);

// exports
